import { z } from 'zod/v4';
// Assuming AttributeModifiersDTO is a zod schema imported here:

export const AttributeValueRequestDTO = z.object({
  attribute_id: z.string(),
  value_id: z.string().optional(),
  value: z.any(),
});
export type AttributeValueRequest = z.infer<typeof AttributeValueRequestDTO>;

export const AttributeHistoryDTO = z.object({
  value: z.string(),
  value_id: z.string(),
  start_date: z.string(),
  end_date: z.string().nullable(),
});
export type AttributeHistory = z.infer<typeof AttributeHistoryDTO>;

export const AllAttributeHistoryDTO = z.record(z.string(), AttributeHistoryDTO);
export type AllAttributeHistory = z.infer<typeof AllAttributeHistoryDTO>;